module.exports = __webpack_public_path__ + "static/media/login-background.cb0572ab.jpg";